<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>
                    <v-btn @click="$router.go(-1)" outlined style="border: none;margin-right: 10px" title="Retour"><v-icon>mdi mdi-arrow-left</v-icon></v-btn>
                    {{$t('settingstrans.management')}} {{devisehistoriques[0]._devise_from_id._name}}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="devisehistoriques"
                        :search="search"
                        sort-by="name"
                        class="elevation-1"
                        :loading="loadhis"
                        loading-text="Chargement en cours..."

                >

                    <template v-slot:item._user="{ item }">
                       <span>{{item._user._first_name}} {{item._user._last_name}} </span>
                    </template>

                    <template v-slot:item._rate="{ item }">
                        <v-chip color="primary" dark>{{ item._rate }} %</v-chip>
                    </template>

                    <template v-slot:item._created_at="{ item }">
                       <span>{{getformatDate(item._created_at)}}</span>
                    </template>




                    <template v-slot:no-data>
                        {{$t('no_data')}}
                    </template>
                </v-data-table>
            </v-card>
        </div>
    </div>

</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";

    export default {

        label: "Cities",
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                errors:undefined,
                search: '',
                dialog: '',
                id: undefined,
                headers: [

                    {text: "Monnaie", value: '_devise_to_id._name'},
                    {text: "Taux", value: '_rate', sortable: false},
                    {text: "Taux d'échange", value: '_markup_rate', sortable: false},
                    {text: "Utilisateur", value: '_user', sortable: false},
                    {text: "Date", value: '_created_at', sortable: false},

                ],
                editedIndex: -1,
                editedItem: {
                    _taux: 1,
                    _means_paiement: '',
                    _id: 0,
                    _created_at: 0,
                },
                defaultItem: {
                    _taux: 1,
                    _means_paiement: '',
                    _id: 0,
                    _created_at: 0,
                },
                meanspaiementsRules: [
                    v => !!v || 'Choix requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ]

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.$t('settingstrans.new') : this.$t('settingstrans.update')
            }
            ,
            ...mapState('devises/',['devisehistoriques','loadhis'])

        }
        ,
        mounted() {

            let data = new FormData();
            data.append("id", this.$route.params.id);
            this.$store.dispatch('devises/getDeviseHistoriques',data).then(response => {
                window.console.log('devises', response)
            });


        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            }
            ,

            editItem(item) {
                this.editedIndex = this.settingtransactions.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.editedItem._means_paiement = item._means_paiement._id;
                this.editedItem._taux = item._taux;
                this.editedItem._id = item._id;
                console.log("this.editedItem",this.editedItem);
                this.dialog = true;
            }
            ,

            deleteItem(item) {
                const index = this.settingtransactions.indexOf(item);
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('delete_warning'),
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        let data = new FormData();
                        data.append("id", item._id);
                        data.append("marchand_id", this.$route.params.id);
                        this.$store.dispatch('settingtransactions/deleteSetting', data).then((result) => {
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: this.$t(result.message),
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save() {
                console.log(this.editedItem);
                this.submitting = true;
                let data = new FormData();
                data.append("taux", this.editedItem._taux);
                data.append("means", this.editedItem._means_paiement);
                data.append("marchand_id", this.$route.params.id);
                let mineroute = 'settingtransactions/setSetting';
                if (this.editedIndex>-1){
                    data.append("id",this.editedItem._id);
                    mineroute = 'settingtransactions/updateSetting';
                }
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('set cities response', response);
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.message;
                    } else {
                        this.close();
                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            fileChange() {
                console.log(this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file) {
                return file.substr(file.lastIndexOf('/') + 1)
            },
            getformatDate(value) {
                if (value) {
                    return Intl.DateTimeFormat('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: "numeric",
                        minute: "2-digit",
                        second: "2-digit"
                    }).format(new Date(value));
                }
            },
            checkIfExist(){
                let VueBox = this;
                if (VueBox.editedIndex>-1){
                    return VueBox.values.find(value => value._code === VueBox.editedItem.code && value._id !== VueBox.editedItem._id)
                } else{
                    return VueBox.values.find(value => value._code === VueBox.editedItem.code)
                }
            }
        }
        ,
        created() {
            this.checkisDashboard();
            this.initialize()
        }
    }
</script>

<style scoped>

</style>
